import { render } from "./MailSettings.vue?vue&type=template&id=1ea29900"
import script from "./MailSettings.vue?vue&type=script&lang=js"
export * from "./MailSettings.vue?vue&type=script&lang=js"

import exportComponent from "/home/projects/frontend.vendor-mailing-system.pravin/vendor-mailig-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__